import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { GoogleLoginService } from 'src/app/admin/google-login/google-login.service';
import { HeaderService } from './header.service';
import { ContentService } from '../content/content.service';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html'
})

export class HeaderComponent implements OnInit {

  profileImageUrl: any;
  subscription: any;
  userId: any;
  imageSrc: any;
  public userName: any;
  imageUrl: any = '';
  value = '';

  constructor(
    private router: Router,
    private googleLoginService: GoogleLoginService,
    private headerService: HeaderService,
    private contentService: ContentService,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {
    this.getAllCount();
    this.userName = sessionStorage.getItem('user_name');
    this.imageUrl = sessionStorage.getItem('profileImageName');
    this.profileImageUrl = sessionStorage.getItem('profileImageName');
    this.userId = JSON.parse(sessionStorage.getItem('id'));
    this.subscription = this.headerService.getNavChangeEmitter().subscribe(item => this.updateProfileImage(JSON.parse(item)));
    if (this.profileImageUrl != 'null' && this.profileImageUrl != '' && this.profileImageUrl != null) {
      this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        `data:image/png;base64, ${this.profileImageUrl}`
      );
    }
    else {
      this.imageSrc = '';
    }
  }

  getAllCount() {
    this.contentService.sendMyRequest()
    this.contentService.sendResourceRequest()
    this.contentService.getAllCount();
  }

  updateProfileImage(value: any) {
    this.imageUrl = value.imageData
    this.userName = value.vFirstName.charAt(0).toUpperCase() + value.vFirstName.slice(1) + " " + value.vLastName.charAt(0).toUpperCase() + value.vLastName.slice(1)
    sessionStorage.setItem('user_name', this.userName);
    sessionStorage.setItem('profileImageName', this.imageUrl);
    if (value.imageData != null && value.imageData != '' && value.imageData != 'null') {
      this.imageSrc = this.sanitizer.bypassSecurityTrustResourceUrl(
        `data:image/png;base64, ${value.imageData}`
      );
    }
    else {
      this.imageSrc = '';
    }
  }

  signOut(): void {
    let token = sessionStorage.getItem('token');
    sessionStorage.clear();
    localStorage.clear();
    this.googleLoginService.logout({ token: token }).subscribe((result: any) => {
      this.router.navigate(['/login']);
    }, (err: any) => {
      this.router.navigate(['/login']);
      console.log(err, "error");
    })
  }
}
